<template>
    <div>
        <span class="coupon-label">
            {{ $t('coupon.hour') }}
        </span>
        <span>{{ hour }}</span>
        <show-timezone-code
            :is-virtual-service="isVirtualService"
        />
        <span v-if="duration">
            ({{ duration }} min)
        </span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatTimefromJsDate } from '@/utils';
import ShowTimezoneCode from '@/components/timezones/ShowTimezoneCode';
import { formatToTimeZone } from 'date-fns-timezone';
import { format, parse } from 'date-fns';
import { EstablishmentSetting } from '@/enums';

export default {
    name: 'coupon-appt-hour',
    props: {
        appointment: { type: Object, required: true },
        service: { type: Object, required: true },
        isVirtualService: { type: Boolean, required: false, default: false },
    },
    components: {
        ShowTimezoneCode,
    },
    computed: {
        ...mapGetters({
            establishmentSettings: 'establishment/getSettings',
            getEstablishmentSettingById: 'establishment/getEstablishmentSettingById',
        }),

        /**
         * Returns service's duration based on the service's config
         */
        duration() {
            if (this.service) {
                return this.service.activateDurationInPublicPage
                    ? this.service.length
                    : '';
            }
            return '';
        },

        /**
         * Returns appointment's formatted hour
         */
        hour() {
            const formatDate = 'YYYY-MM-DD HH:mm:ss.SSS';
            let start = format(parse(this.appointment.start), formatDate);
            if (this.isVirtualService) {
                start = formatToTimeZone(start, formatDate, { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
            }
            else {
                start = formatToTimeZone(start, formatDate, { timeZone: this.getEstablishmentSettingById(EstablishmentSetting.DEFAULT_TIMEZONE) });
            }
            return formatTimefromJsDate(start);
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
